// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlueToggleContainer {
    display: flex;
    gap: 1em;
    width: auto;
    justify-content: space-between;
}

.BlueToggleContainerToggle {
    padding-top: 0.8em;
    width: auto;
    right: 0;
}

.BlueToggle {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 24px;
}

.BlueToggle input {
    opacity: 0;
    width: 0;
    height: 0;
}

.BlueToggleSlider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--LiterGrayBlue);
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 24px;
}

.BlueToggleSlider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 4px;
    background-color: var(--DarkBlue);
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
}

input:checked + .BlueToggleSlider {
    background-color: var(--HighlightBlue);
}

input:focus + .BlueToggleSlider {
    box-shadow: 0 0 1px var(--HighlightBlue);
}

input:checked + .BlueToggleSlider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

.BlueToggleTitle {
}
`, "",{"version":3,"sources":["webpack://./src/components/common/BlueToggle/BlueToggle.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,QAAQ;IACR,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sCAAsC;IACtC,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,iCAAiC;IACjC,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,mCAAmC;IACnC,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA;AACA","sourcesContent":[".BlueToggleContainer {\n    display: flex;\n    gap: 1em;\n    width: auto;\n    justify-content: space-between;\n}\n\n.BlueToggleContainerToggle {\n    padding-top: 0.8em;\n    width: auto;\n    right: 0;\n}\n\n.BlueToggle {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 24px;\n}\n\n.BlueToggle input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.BlueToggleSlider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: var(--LiterGrayBlue);\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n    border-radius: 24px;\n}\n\n.BlueToggleSlider:before {\n    position: absolute;\n    content: \"\";\n    height: 16px;\n    width: 16px;\n    left: 2px;\n    bottom: 4px;\n    background-color: var(--DarkBlue);\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n    border-radius: 50%;\n}\n\ninput:checked + .BlueToggleSlider {\n    background-color: var(--HighlightBlue);\n}\n\ninput:focus + .BlueToggleSlider {\n    box-shadow: 0 0 1px var(--HighlightBlue);\n}\n\ninput:checked + .BlueToggleSlider:before {\n    -webkit-transform: translateX(26px);\n    -ms-transform: translateX(26px);\n    transform: translateX(26px);\n}\n\n.BlueToggleTitle {\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
